export default __webpack_public_path__ + "static/media/teams_default.23d1d865.mp3";